/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import {
  APPLICATION_STATUS_ALIMONY,
  APPLICATION_STATUS_BASIC,
  APPLICATION_STATUS_CHILDREN,
  APPLICATION_STATUS_CONTACT,
  APPLICATION_STATUS_DOCUMENTS,
  APPLICATION_STATUS_INSURANCE,
  APPLICATION_STATUS_MESSAGE,
  APPLICATION_STATUS_PARTNER,
  APPLICATION_STATUS_PETITIONER,
  APPLICATION_STATUS_SUMMARY,
} from "./applicationStatus";
import HintBox from "@/src/components/Box/HintBox/HintBox";
import React from "react";
import ProgressBar from "@/src/components/ProgressBar/ProgressBar";
import progressBarsteps from "./progressBarSteps";
import AlimonyPerson from "@/src/components/Form/FamilyLaw/Alimony/AlimonyPerson";
import Alimony from "@/src/components/Form/FamilyLaw/Alimony/Alimony";
import AlimonyChildren from "@/src/components/Form/FamilyLaw/Alimony/AlimonyChildren";
import Summary from "@/src/components/Form/FamilyLaw/Alimony/Summary";
import AlimonyChoice from "@/src/components/Form/FamilyLaw/Alimony/AlimonyChoice";
import Insurance from "@/src/components/Form/Common/Insurance/Insurance";
import Documents from "@/src/components/Form/Common/Documents/Documents";
import PersonalTextMessage from "@/src/components/Form/Common/PersonalTextMessage/PersonalTextMessage";
import Personal from "@/src/components/Form/Common/Personal/Personal";
import { FormSteps } from "@/src/types/FormServiceBase";
import SummaryHintBox from "@/src/components/Form/Common/SummaryHintBox";

const formSteps: FormSteps = {
  [APPLICATION_STATUS_BASIC]: {
    title: "Antrag - Ihr Anliegen | Legalbird",
    stepUrl: "ihre-analyse",
    applicationStatus: APPLICATION_STATUS_BASIC,
    render: (props) => (
      <>
        <HintBox headline={"Ihre persönliche Unterhaltsberechnung"}>
          <p>
            Sie können auf den folgenden Seiten Angaben zu Ihrer Situation machen und den individuellen Kindes- und ggf. Ehegattenunterhalt berechnen lassen. Im
            Anschluss erhalten Sie eine detaillierte Berechnung sowie eine individuelle Analyse inklusive Link zur Terminvereinbarung eines Erstgesprächs mit
            einem Fachanwalt, damit Sie all Ihre Fragen in Ruhe besprechen können.
          </p>
        </HintBox>
        <ProgressBar steps={progressBarsteps} active={"base"} progress={6} />
        <AlimonyChoice {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_ALIMONY]: {
    title: "Antrag - Angaben zum Unterhalt | Legalbird",
    stepUrl: "angaben-zum-unterhalt",
    applicationStatus: APPLICATION_STATUS_ALIMONY,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"calculate"} progress={22} />
        <Alimony {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_CHILDREN]: {
    title: "Antrag - Kinder | Legalbird",
    stepUrl: "kinder",
    applicationStatus: APPLICATION_STATUS_CHILDREN,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"calculate"} progress={27} />
        <AlimonyChildren {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_PETITIONER]: {
    title: "Antrag - Ihre Angaben | Legalbird",
    stepUrl: "finanzielle-situation",
    applicationStatus: APPLICATION_STATUS_PETITIONER,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"calculate"} progress={30} />
        <AlimonyPerson {...props} personType={"alimonyPetitioner"} key={"alimonyPetitioner"} />
      </>
    ),
  },
  [APPLICATION_STATUS_PARTNER]: {
    title: "Antrag - Ihre Angaben | Legalbird",
    stepUrl: "finanzielle-situation-partner",
    applicationStatus: APPLICATION_STATUS_PARTNER,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"calculate"} progress={33} />
        <AlimonyPerson {...props} personType={"alimonyPartner"} key={"alimonyPartner"} />
      </>
    ),
  },
  [APPLICATION_STATUS_MESSAGE]: {
    title: "Antrag - Ihr Anliegen | Legalbird",
    stepUrl: "ihr-anliegen",
    applicationStatus: APPLICATION_STATUS_MESSAGE,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"question"} progress={38} />
        <PersonalTextMessage {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_DOCUMENTS]: {
    title: "Antrag - Unterlagen | Legalbird",
    applicationStatus: APPLICATION_STATUS_DOCUMENTS,
    stepUrl: "unterlagen",
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"documents"} progress={55} />
        <Documents {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_CONTACT]: {
    title: "Antrag - Kontaktdaten | Legalbird",
    stepUrl: "kontaktdaten",
    applicationStatus: APPLICATION_STATUS_CONTACT,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"personal"} progress={71} />
        <Personal {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_INSURANCE]: {
    title: "Antrag - Versicherung | Legalbird",
    applicationStatus: APPLICATION_STATUS_INSURANCE,
    stepUrl: "versicherung",
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"insurance"} progress={88} />
        <Insurance {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_SUMMARY]: {
    title: "Antrag - Überprüfen | Legalbird",
    stepUrl: "ueberpruefen",
    applicationStatus: APPLICATION_STATUS_SUMMARY,
    render: (props) => (
      <>
        <SummaryHintBox />
        <Summary {...props} />
      </>
    ),
  },
};

export default formSteps;
